import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { LinkButton } from "components/buttons";

function FloatingRate() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Deposits"
          title={`Floating Rate<br>
              <span className="jumbotron-subtitle-2">
                Term Deposit-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Floating Rate Term Deposit-<i>i</i> (FRTD-<i>i </i>) is a
              Shariah-compliant term deposit that enables you the opportunity to
              enjoy potential increases in the profit rates landscape between
              lock-in periods. And you won’t need to rearrange for the next
              tenure; the Effective Profit Rate (EPR) shall be reset at the end
              of each Repricing Period and the updated EPR will be applicable to
              the following Repricing Period and Profit Period. alrajhi bank
              Malaysia determines the rates in-house, correlating them with
              Malaysia’s dynamic profit rate landscape.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row ">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Returns </div>
                <div className="column-subheader-2">
                  Potential to get better returns{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Selection of tenures</div>
                <div className="column-subheader-2">
                  Choice of selection of tenures that ranges between 12 and 60
                  months{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Flexibility</div>
                <div className="column-subheader-2">
                  Flexibility on when profit is paid **{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Standard</div>
                <div className="column-subheader-2">
                  FRTD-<em>i</em> complies with alrajhi bank Malaysia’s globally
                  trusted Shariah standards{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement){" "}
                </div>
              </div>
            </div>
            <div className="py-5">
              <p>
                Kindly take note that for any pre-matured withdrawal, profit
                shall be clawback/forfeited should the FRTD-i be uplifted prior
                to its stated tenure.
              </p>
            </div>
            <div className="link-button-row">
              <LinkButton
                text={
                  <span>
                    Floating Rate Term Deposit-<em>i</em> Board Rate
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/FRTD-i Board Rate.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    Floating Rate Term Deposit-<em>i</em> Placement Form (ENG)
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/FRTD-i Placement Form_30 June 2023.pdf "
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    Floating Rate Term Deposit-<em>i</em> Placement Form (BM)
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/FRTD-i_Placement_Form_BM_30June23.pdf"
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet (ENG)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/PDS_FRTD-i ENG_4 July 2023.pdf"
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet (BM)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/PDS_FRTD-i_BM_4July23.pdf"
                  )
                }
              />
              <LinkButton
                text="FAQ (ENG)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/FAQ for FRTD-i v1 - Final (Clean Version).pdf "
                  )
                }
              />
              <LinkButton
                text="FAQ (BM)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/FAQ_FRTD-i_BM.pdf "
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default FloatingRate;
